import { InjectionToken } from '@angular/core';
import { ChartDataStatusPublisher } from '../interfaces/chart-data-status-publisher.interface';

/**
 * No root factory on purpose: unlike `COMPONENT_STATE`, this must never
 * resolve to a shared singleton — each page's subscribers must report to
 * that page's own registry, never leak into another tab's. A component not
 * hosted under a page that provides this token has nothing to report to, and
 * every injection site uses `{ optional: true }` to make that a no-op.
 */
export const CHART_DATA_STATUS_PUBLISHER = new InjectionToken<ChartDataStatusPublisher>(
  'ChartDataStatusPublisher',
);
